import BrandIconBlack from '@/components/icons/brand-icon-black';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import GetExetelDesktop from '@/assets/images/get-exetel/get-exetel-app-desktop.png';
import { APP_LINKS } from '@/components/cms/cms-placeholder/common';
import PlayStore from '@/assets/images/app-badges/play-store.svg';
import AppStore from '@/assets/images/app-badges/app-store.svg';
import QR from '@/assets/images/qr/qr.png';
import { Link } from '@tanstack/react-router';
import { FEATURES } from './constant';
import CheckCircle from '../icons/check-circle';
const GetExetelAppDesktop = () => {
  return (
    <div className="max-w-[1440px] mx-auto flex">
      <div>
        <div className="pl-[64px] xl:pl-[156px] py-6">
          <BrandIconBlack className="w-[92.79px] h-6" />
        </div>

        <div className="pl-[64px] pr-[80px] xl:pl-[156px] pt-24 xl:pr-[147px]">
          <Link to="/" className="w-max flex gap-2 justify-start">
            <ArrowLeftIcon className="size-6 text-grey-900" />
            <span className="text-base font-nunito500 text-grey-700">
              Back to homepage
            </span>
          </Link>
          <h2 className="text-3xl font-nunito700 text-black mt-4">
            You are on the One plan which means you will need to download the
            Exetel App to manage your service.
          </h2>

          <div className="mt-6">
            <h3 className="text-lg font-nunito700 text-black">
              Enjoy all the features in the App
            </h3>

            <div className="flex flex-col gap-2 mt-4">
              {FEATURES.map((item, index) => {
                return (
                  <div className="flex" key={index}>
                    <CheckCircle className="size-6 shrink-0 mr-2" />{' '}
                    <p className="text-lg font-nunito300 text-black">{item}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="bg-warp-green-50 rounded-2xl flex p-6 justify-between mt-8">
            <div className="flex flex-col w-[255px] gap-4">
              <h3 className="text-lg font-nunito700 text-black">
                Scan the QR code
                <br />
                to get the Exetel App
              </h3>
              <div className="flex gap-[6px]">
                <a href={APP_LINKS.appStore} target="_blank">
                  <div className="inline-block">
                    <img src={AppStore} alt="appstore" loading="lazy" />
                  </div>
                </a>
                <a href={APP_LINKS.playStore} target="_blank">
                  <div className="inline-block">
                    <img src={PlayStore} alt="playstore" loading="lazy" />
                  </div>
                </a>
              </div>
            </div>

            <div className="shrink-0">
              <img src={QR} loading="lazy" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-warp-green-100 flex items-start h-screen w-[588px] shrink-0">
        <img className="" src={GetExetelDesktop} loading="lazy" />
      </div>
    </div>
  );
};

export { GetExetelAppDesktop };
